import { SlideDataServices } from './core/slide-data-services.core';
import { IPresentationStoreService } from '@src/slide/domain/slide-app/core/interfaces/presentation-service.interface';

const transaction = (action: () => void) => {
    const presentationStoreService = SlideDataServices.SDKDataServices.PresentationStoreService();
    if (!presentationStoreService?.getTransaction()) {
        return action();
    }
    return presentationStoreService.getTransaction()(action);
};

/**
 * 以前业务场景下，事务是个单例，只考虑文档本身的修改
 * 现在增加的模版美化、模版修复、预览等场景实际上是基于clone的sdk做的，因此要区分事务
 * @param storeService clone的sdkStoreService
 */
const getTransactionByStoreService = (storeService: IPresentationStoreService) => (action: () => void) => {
    if (!storeService?.getTransaction()) {
        return action();
    }
    return storeService.getTransaction()(action);
};

export {
    transaction,
    getTransactionByStoreService,
};
